import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import FormControl from "../FormControl";
import FormGroup from "../FormGroup";
import FormLabel from "../FormLabel";
import { styles } from "./styles";
import deprecated from "prop-types-extra/lib/deprecated";
export class Range extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onChange", key => (event, value) => {
      const {
        onChange
      } = this.props;
      value = value ? value : event.target.value;
      onChange && onChange(event, {
        ...this.props.value,
        [key]: value
      });
    });
    _defineProperty(this, "onExecuteValidation", key => value => {
      const {
        executeValidation
      } = this.props;
      const currentValue = this.props;
      executeValidation && executeValidation({
        ...currentValue.value,
        [key]: value
      });
    });
    _defineProperty(this, "fullWidth", () => {
      const {
        fromProps,
        toProps,
        fullWidth
      } = this.props;
      return fullWidth || fromProps && fromProps.fullWidth || toProps && toProps.fullWidth;
    });
    _defineProperty(this, "render", () => {
      const {
        autoFocus,
        component: Component,
        classes,
        disabled,
        error,
        fromProps,
        id,
        label,
        required,
        toProps,
        value,
        onBlur,
        className
      } = this.props;
      const {
        from,
        to
      } = value || {
        from: null,
        to: null
      };
      const fromId = id ? `${id}-range-from` : undefined;
      const rootLabelProps = {
        id: id,
        htmlFor: fromId,
        disabled: disabled
      };
      const fromComponentProps = {
        ...fromProps,
        autoFocus: autoFocus,
        fullWidth: this.fullWidth(),
        id: fromId,
        onChange: this.onChange("from"),
        // This is meant to be invoked. It is a function returning a function.
        onBlur: onBlur,
        executeValidation: this.onExecuteValidation("from"),
        value: from,
        required: required,
        disabled: disabled
      };
      const toComponentProps = {
        ...toProps,
        fullWidth: this.fullWidth(),
        id: id ? `${id}-range-to` : undefined,
        onChange: this.onChange("to"),
        // This is meant to be invoked. It is a function returning a function.
        onBlur: onBlur,
        executeValidation: this.onExecuteValidation("to"),
        required: required,
        value: to,
        disabled: disabled
      };
      return /*#__PURE__*/React.createElement(FormControl, {
        fullWidth: this.fullWidth(),
        id: id,
        disabled: disabled,
        error: error,
        required: required
      }, label && /*#__PURE__*/React.createElement(FormLabel, _extends({
        className: classNames("prmbl-range-label", classes.rangeLabel),
        component: "label"
      }, rootLabelProps), label), /*#__PURE__*/React.createElement(FormGroup, {
        id: id ? id + "-range-group" : undefined,
        className: classNames("prmbl-range", className, classes.root)
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames("prmbl-range-component", classes.component, {
          [classes.componentFullWidth]: this.fullWidth()
        })
      }, /*#__PURE__*/React.createElement(Component, _extends({}, fromComponentProps, {
        margin: false
      }))), /*#__PURE__*/React.createElement("div", {
        className: classNames("prmbl-range-component", classes.component, {
          [classes.componentFullWidth]: this.fullWidth()
        })
      }, /*#__PURE__*/React.createElement(Component, _extends({}, toComponentProps, {
        margin: false
      })))));
    });
  }
}
_defineProperty(Range, "propTypes", {
  /**
   * Deprecated: autoFocus causes accessibility issues and should be avoided.
   * If `true`  the input will be focused during the first mount.
   */
  autoFocus: deprecated(PropTypes.bool, "autoFocus causes accessibility issues and should be avoided."),
  /**
   * If `true` the label, and input should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: PropTypes.bool,
  /**
   * Classes to apply to the root
   */
  className: PropTypes.string,
  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: PropTypes.object.isRequired,
  /**
   * The component used for the input elements.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.any,
  /**
   * Container to store all the properties for the `from` component
   */
  fromProps: PropTypes.object,
  /**
   * The html id
   */
  id: PropTypes.string,
  /**
   * The contents of the `label`
   */
  label: PropTypes.node,
  /**
   * Callback fired when the value is changed.  `function(event: object, value: object) => void`
   *
   * `event` : The event source of the callback.
   *
   *
   * `value` : The value of the range. { from: ..., to: ... }
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Callback to be called when the user switches focus from the input
   *
   * function(event: object) => void
   * `event` : The event source of the callback.
   */
  onBlur: PropTypes.func,
  /**
   * Function passed in from /Validation/index.js.. Used to bypass the checks inside index.js and call validation directly.
   */
  executeValidation: PropTypes.func,
  /**
   * Sets the label component to visually represent a required field.
   */
  required: PropTypes.bool,
  /**
   * Container to store all the properties for the `to` component
   */
  toProps: PropTypes.object,
  /**
   * The value of the range object
   */
  value: PropTypes.shape({
    /**
     * Value of the `From` input
     */
    from: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
    /**
     * Value of the `To` input
     */
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
  }),
  /**
   * Makes the Range width 100%
   */
  fullWidth: PropTypes.bool,
  /**
   *  Helper text
   */
  helperText: PropTypes.string
});
export default withStyles(styles)(Range);